import { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { useOnboardingStore } from '../../store/useOnboardingStore';
import { Link } from 'react-router-dom';
import logo from "../../assets/images/logo_2.png";
import React from 'react';

/* ═══════════════════════════════════════════════════
   INJECT STYLES
═══════════════════════════════════════════════════ */
const injectStyles = () => {
  if (document.getElementById("ob4-styles")) return;
  const s = document.createElement("style");
  s.id = "ob4-styles";
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    @keyframes slideInBot {
      from { opacity:0; transform:translateY(-8px) scale(0.96); }
      to   { opacity:1; transform:translateY(0)    scale(1);    }
    }
    @keyframes botCursor { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes speakBar  { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.9)} }
    @keyframes pulseDot  { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes botBobSvg { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes floatHeartL1 {
      0%  { transform:translate(0,0)         scale(1);    opacity:1; }
      100%{ transform:translate(-14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartL2 {
      0%  { transform:translate(0,0)        scale(0.82); opacity:0.9; }
      100%{ transform:translate(-4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartL3 {
      0%  { transform:translate(0,0)       scale(0.68); opacity:0.8; }
      100%{ transform:translate(9px,-50px) scale(0.22); opacity:0; }
    }
    @keyframes floatHeartR1 {
      0%  { transform:translate(0,0)        scale(1);    opacity:1; }
      100%{ transform:translate(14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartR2 {
      0%  { transform:translate(0,0)       scale(0.82); opacity:0.9; }
      100%{ transform:translate(4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartR3 {
      0%  { transform:translate(0,0)        scale(0.68); opacity:0.8; }
      100%{ transform:translate(-9px,-50px) scale(0.22); opacity:0; }
    }
    @keyframes ob4-shimmer { 0%{background-position:200% center} 100%{background-position:-200% center} }

    .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
    .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    .ob4-wrap { position:fixed; z-index:99999; animation:slideInBot .28s cubic-bezier(.34,1.2,.64,1) both; }
    .ob4-wrap::before { content:''; position:absolute; width:16px; height:9px; background:#c0001a; clip-path:polygon(50% 0%,100% 100%,0% 100%); }
    .ob4-wrap.below::before   { top:-9px;    left:24px; }
    .ob4-wrap.above::before   { bottom:-9px; left:24px; transform:rotate(180deg); }
    .ob4-wrap.toright::before { top:24px;    left:-9px; transform:rotate(-90deg); }
    .ob4-wrap.toleft::before  { top:24px;    right:-9px; transform:rotate(90deg); }

    .ob4-card-popup {
      background:#fff; border-radius:14px; border:1px solid rgba(0,0,0,.07); overflow:hidden;
      box-shadow:0 4px 8px rgba(0,0,0,.06),0 18px 52px rgba(0,0,0,.18),0 2px 10px rgba(192,0,26,.1);
    }
    .ob4-hd {
      background:linear-gradient(135deg,#c0001a 0%,#8b0000 58%,#5c0000 100%);
      padding:12px 14px 10px; display:flex; align-items:center; gap:10px;
      position:relative; overflow:visible;
    }
    .ob4-hd::after {
      content:''; position:absolute; inset:0; pointer-events:none;
      background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),
                       linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px);
      background-size:16px 16px;
    }
    .ob4-av   { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .ob4-bars { display:flex; align-items:flex-end; gap:2px; position:absolute; bottom:-3px; right:-4px; background:rgba(0,0,0,.3); border-radius:4px; padding:2px 3px; z-index:2; }
    .ob4-b    { width:2.5px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .ob4-b:nth-child(1){ height:4px;  animation:speakBar .48s .00s ease-in-out infinite; }
    .ob4-b:nth-child(2){ height:9px;  animation:speakBar .48s .10s ease-in-out infinite; }
    .ob4-b:nth-child(3){ height:6px;  animation:speakBar .48s .20s ease-in-out infinite; }
    .ob4-b:nth-child(4){ height:3px;  animation:speakBar .48s .30s ease-in-out infinite; }
    .ob4-meta { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .ob4-name { font-size:11.5px; font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .ob4-sub  { font-size:9.5px; color:rgba(255,255,255,.7); display:flex; align-items:center; gap:4px; margin-top:2px; }
    .ob4-dot  { width:5px; height:5px; border-radius:50%; background:#6effa0; box-shadow:0 0 4px rgba(100,255,150,.85); flex-shrink:0; animation:pulseDot 2s ease-in-out infinite; }
    .ob4-badge{ z-index:1; flex-shrink:0; background:rgba(255,255,255,.16); border:1px solid rgba(255,255,255,.3); border-radius:20px; padding:2px 8px; font-size:10px; font-weight:700; color:#fff; white-space:nowrap; }
    .ob4-tag     { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(192,0,26,.1); padding:5px 14px; display:flex; align-items:center; gap:6px; }
    .ob4-tag-dot { width:5px; height:5px; border-radius:50%; background:#c0001a; flex-shrink:0; }
    .ob4-tag-txt { font-size:9.5px; font-weight:800; color:#c0001a; letter-spacing:.08em; }
    .ob4-body { padding:10px 14px 8px; }
    .ob4-msg  { font-size:13px; line-height:1.62; color:#1a1a1a; word-break:break-word; margin:0; }
    .ob4-msg strong { color:#c0001a; font-weight:800; }
    .ob4-cur  { display:inline-block; width:2px; height:13px; background:#c0001a; border-radius:2px; margin-left:2px; vertical-align:middle; animation:botCursor .65s ease-in-out infinite; }
    .ob4-ft   { padding:8px 14px 11px; display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; }
    .ob4-dots { display:flex; gap:4px; align-items:center; }
    .ob4-d    { width:6px; height:6px; border-radius:50%; background:#e0e0e0; transition:all .3s; }
    .ob4-d.on { width:18px; border-radius:999px; background:linear-gradient(90deg,#c0001a,#8b0000); }
    .ob4-skip { background:none; border:none; cursor:pointer; font-size:11px; color:#c0c0c0; padding:4px 6px; border-radius:6px; transition:all .18s; white-space:nowrap; }
    .ob4-skip:hover { background:#f0f0f0; color:#888; }
    .ob4-next { background:linear-gradient(135deg,#c0001a,#8b0000); color:#fff; border:none; border-radius:8px; padding:7px 16px; font-size:12px; font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 3px 12px rgba(192,0,26,.32); transition:all .18s; white-space:nowrap; }
    .ob4-next:hover  { transform:translateY(-1px); box-shadow:0 5px 16px rgba(192,0,26,.46); }
    .ob4-next:active { transform:scale(.97); }

    .ob4-section { background:#f8f5f0 !important; min-height:100vh !important; }

    .ob4-prog-wrap { display:flex !important; gap:5px !important; margin-top:10px !important; }
    .ob4-prog-bar  { height:4px !important; border-radius:999px !important; flex:1 !important; background:#e2e8f0 !important; }
    .ob4-prog-bar.done   { background:linear-gradient(90deg,#c0001a,#8b0000) !important; }
    .ob4-prog-bar.active { background:linear-gradient(90deg,#e0001f,#c0001a) !important; animation:ob4-shimmer 2s linear infinite !important; background-size:200% auto !important; }

    .ob4-q-block {
      padding: 18px 0 !important;
      border-bottom: 1px solid #e8e3dc !important;
      position: relative !important;
    }
    .ob4-q-block:last-of-type { border-bottom: none !important; }

    .ob4-q-title {
      font-size: 15px !important; font-weight: 600 !important; color: #1a1a1a !important;
      margin: 0 0 14px !important; display: block !important;
      font-family: 'Inter', sans-serif !important; line-height: 1.45 !important;
    }

    .ob4-textarea {
      width:100% !important; border:1.5px solid #d4cfc8 !important; border-radius:10px !important;
      padding:13px 14px !important; font-size:13.5px !important; font-family:'Inter',sans-serif !important;
      color:#0f172a !important; background:#fff !important; outline:none !important;
      box-shadow:none !important; resize:vertical !important;
      transition:border-color .15s,box-shadow .15s !important;
      line-height:1.65 !important; min-height:115px !important;
    }
    .ob4-textarea:focus { border-color:#c0001a !important; box-shadow:0 0 0 3px rgba(192,0,26,.1) !important; }
    .ob4-textarea::placeholder { color:#adb5bd !important; }
    .ob4-char     { font-size:11px !important; color:#94a3b8 !important; font-family:'Inter',sans-serif !important; }
    .ob4-char.over{ color:#dc2626 !important; }

    .ob4-pill {
      display:inline-flex !important; align-items:center !important;
      border:1.5px solid #d0cbc3 !important; border-radius:999px !important;
      background:transparent !important; color:#374151 !important;
      font-size:13px !important; font-weight:500 !important; padding:8px 20px !important;
      cursor:pointer !important; font-family:'Inter',sans-serif !important;
      transition:border-color .14s,background .14s,color .14s,box-shadow .14s !important;
      margin:0 7px 8px 0 !important; outline:none !important;
    }
    .ob4-pill:hover { border-color:rgba(192,0,26,.5) !important; color:#c0001a !important; }
    .ob4-pill.ob4-sel {
      border-color:#c0001a !important; color:#c0001a !important; font-weight:600 !important;
      box-shadow:0 0 0 3px rgba(192,0,26,.08) !important;
    }

    .ob4-btn-continue {
      display:inline-flex !important; align-items:center !important; gap:8px !important;
      background:linear-gradient(135deg,#c0001a,#8b0000) !important;
      color:#fff !important; border:none !important; border-radius:10px !important;
      padding:12px 28px !important; font-size:14px !important; font-weight:700 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      letter-spacing:.02em !important; box-shadow:0 3px 14px rgba(192,0,26,.35) !important;
      transition:transform .18s,box-shadow .18s !important;
    }
    .ob4-btn-continue:hover  { transform:translateY(-1px) !important; box-shadow:0 5px 20px rgba(192,0,26,.48) !important; }
    .ob4-btn-continue:active { transform:scale(.97) !important; }
    .ob4-btn-continue.ob4-lit { background:linear-gradient(135deg,#e0001f,#c0001a) !important; }

    .ob4-btn-back {
      display:inline-flex !important; align-items:center !important; gap:7px !important;
      border:1.5px solid #d0cbc3 !important; background:transparent !important; color:#374151 !important;
      border-radius:10px !important; padding:11px 22px !important;
      font-size:14px !important; font-weight:600 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      transition:border-color .15s,background .15s !important;
    }
    .ob4-btn-back:hover { border-color:#94a3b8 !important; }

    .ob4-err { font-size:11.5px !important; color:#dc2626 !important; margin-top:6px !important; font-family:'Inter',sans-serif !important; }

    /* ── Mobile: compact, exact-anchor-aligned, overlap-safe bot popup ── */
    @media (max-width: 767px) {
      .ob4-wrap        { max-width:calc(100vw - 24px); }
      .ob4-card-popup  { border-radius:10px; }
      .ob4-hd          { padding:7px 8px 6px; gap:6px; }
      .ob4-av svg      { width:34px !important; height:34px !important; }
      .ob4-bars        { padding:1px 2px; bottom:-2px; right:-2px; }
      .ob4-b           { width:1.5px; }
      .ob4-name        { font-size:9px; letter-spacing:.03em; }
      .ob4-sub         { font-size:7.5px; }
      .ob4-dot         { width:4px; height:4px; }
      .ob4-badge       { font-size:8px; padding:1px 5px; }
      .ob4-tag         { padding:3px 8px; }
      .ob4-tag-dot     { width:4px; height:4px; }
      .ob4-tag-txt     { font-size:7.5px; }
      .ob4-body        { padding:6px 8px 5px; }
      .ob4-msg         { font-size:11px; line-height:1.4; }
      .ob4-ft          { padding:5px 8px 7px; }
      .ob4-skip        { font-size:9px; padding:2px 4px; }
      .ob4-next        { font-size:10px; padding:5px 10px; }
      .ob4-d           { width:4px; height:4px; }
      .ob4-d.on        { width:12px; }
    }
  `;
  document.head.appendChild(s);
};

/* ═══════════════════════════════════════════════════
   BOT FACE SVG
═══════════════════════════════════════════════════ */
const BotFaceSVG: React.FC = () => (
  <svg width="64" height="64" viewBox="0 0 72 72" fill="none" style={{ overflow: "visible" }}>
    <defs>
      <style>{`
        .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
        .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="ob-bot-bob">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)" />
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)" />
      <circle cx="7"  cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#c0001a" />
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000" />
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white" />
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white" />
      <g className="ob-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b" /></g>
      <g className="ob-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099" /></g>
      <g className="ob-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b" /></g>
      <g className="ob-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099" /></g>
      <path d="M16,46 Q36,60 56,46" stroke="#c0001a" strokeWidth="2.8" strokeLinecap="round" fill="none" />
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <line x1="7"  y1="28" x2="2"  y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="7"  y1="36" x2="2"  y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
    </g>
  </svg>
);

/* ═══════════════════════════════════════════════════
   TYPES
═══════════════════════════════════════════════════ */
type BotSide = "below" | "above" | "toright" | "toleft";
interface StepData { tag: string; plain: string; html: React.ReactNode; sideLg: BotSide; }

// Shared sizing constants — used by BotPopup for its own box AND by Step4
// to size the spacer that pushes page content down so the popup never
// overlaps the next question/field. Kept small so the bot stays compact
// and hugs the exact anchor field on mobile.
const GAP = 8;
const POPUP_W_MOBILE = 230, POPUP_W_DESKTOP = 310;
const POPUP_H_MOBILE = 130, POPUP_H_DESKTOP = 240;

/* ═══════════════════════════════════════════════════
   BOT POPUP
═══════════════════════════════════════════════════ */
interface PopupProps {
  anchorRef: React.RefObject<HTMLDivElement | null>;
  step: number; total: number; data: StepData;
  onSkip: () => void; onNext: () => void; nextLabel: string;
}

const BotPopup: React.FC<PopupProps> = ({ anchorRef, step, total, data, onSkip, onNext, nextLabel }) => {
  // Mobile gets a smaller card so it never overlaps form fields or screen edges.
  const isMobileScreen = typeof window !== "undefined" && window.innerWidth < 768;
  const PW = isMobileScreen ? POPUP_W_MOBILE : POPUP_W_DESKTOP;
  const POPUP_H = isMobileScreen ? POPUP_H_MOBILE : POPUP_H_DESKTOP;

  const [pos,        setPos]        = useState<{ top:number; left:number; width:number } | null>(null);
  const [activeSide, setActiveSide] = useState<BotSide>("below");
  const [displayed,  setDisplayed]  = useState("");
  const [done,       setDone]       = useState(false);
  const [status,     setStatus]     = useState("typing...");
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const retryRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const calcPos = useCallback((): boolean => {
    if (!anchorRef.current) return false;
    const r = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    if (r.width === 0 && r.height === 0) return false;

    // Popup always appears BELOW the anchor — never above, never to the side.
    // It hugs the anchor's own left edge (not screen-center) so it visually
    // sits directly under the field it refers to.
    if (vw < 768) {
      const popW = Math.min(vw - 16, PW);
      const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));
      let left = r.left;
      left = Math.max(8, Math.min(left, vw - popW - 8));
      setActiveSide("below");
      setPos({ top, left, width: popW });
      return true;
    }

    let left = r.left;
    if (left + PW > vw - 8) left = vw - PW - 8;
    left = Math.max(12, Math.min(left, vw - PW - 12));

    const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));

    setActiveSide("below");
    setPos({ top, left, width: PW });
    return true;
  }, [anchorRef]);

  useEffect(() => {
    let attempts = 0; const MAX = 50;
    if (retryRef.current) clearTimeout(retryRef.current);
    setPos(null);
    const tryCalc = () => { const ok = calcPos(); if (!ok && attempts < MAX) { attempts++; retryRef.current = setTimeout(tryCalc, 80); } };
    tryCalc();
    window.addEventListener("resize", calcPos);
    window.addEventListener("scroll", calcPos, true);
    return () => { if (retryRef.current) clearTimeout(retryRef.current); window.removeEventListener("resize", calcPos); window.removeEventListener("scroll", calcPos, true); };
  }, [calcPos, step]);

  useEffect(() => {
    setDisplayed(""); setDone(false); setStatus("typing...");
    let i = 0;
    const tick = () => { if (i <= data.plain.length) { setDisplayed(data.plain.slice(0, i)); i++; timerRef.current = setTimeout(tick, 21); } else { setDone(true); setStatus("Online — here to guide you!"); } };
    tick();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [data.plain, step]);

  if (!pos) return null;
  const isSide = activeSide === "toright" || activeSide === "toleft";

  return (
    <div className={`ob4-wrap ${activeSide}`} style={{ top: pos.top, left: pos.left, width: pos.width, transform: isSide ? "translateY(-50%)" : "none" }}>
      <div className="ob4-card-popup" style={{ width: "100%" }}>
        <div className="ob4-hd">
          <div className="ob4-av">
            <BotFaceSVG />
            <div className="ob4-bars"><div className="ob4-b"/><div className="ob4-b"/><div className="ob4-b"/><div className="ob4-b"/></div>
          </div>
          <div className="ob4-meta">
            <div className="ob4-name">SLAMMM GUIDE</div>
            <div className="ob4-sub"><div className="ob4-dot"/><span>{status}</span></div>
          </div>
          <div className="ob4-badge">{step}/{total}</div>
        </div>
        <div className="ob4-tag"><div className="ob4-tag-dot"/><div className="ob4-tag-txt">{data.tag}</div></div>
        <div className="ob4-body">
          {done ? <p className="ob4-msg">{data.html}</p> : <p className="ob4-msg">{displayed}<span className="ob4-cur"/></p>}
        </div>
        <div className="ob4-ft">
          <div className="ob4-dots">{Array.from({ length: total }).map((_, i) => <div key={i} className={`ob4-d${i + 1 === step ? " on" : ""}`}/>)}</div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button className="ob4-skip" onClick={onSkip}>Skip guide</button>
            <button className="ob4-next" onClick={onNext}
              onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.transform = "translateY(-1px)"; }}
              onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.transform = "none"; }}
            >{nextLabel}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════
   STEP 4 — MAIN COMPONENT
═══════════════════════════════════════════════════ */
const Step4 = () => {
  const {
    questions, selectOption, inputs, handleInputChange,
    currentStep, validate4, errors, nextStep, prevStep,
  } = useOnboardingStore();

  const stepQuestions = useMemo(
    () => (questions || []).filter((q: any) => q.step === currentStep),
    [questions, currentStep],
  );

  const [btnLit,       setBtnLit]       = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const typingRef = useRef<number | null>(null);

  useEffect(() => {
    injectStyles();
    const done = stepQuestions.filter((q: any) => q.selected).length;
    if (done > 0) setCurrentIndex(done + 1);
  }, [stepQuestions.length]);

  const TOTAL_BOT = 11;

  /* ── Bot state ── */
  const [botStep, setBotStep] = useState<number | null>(null);
  /* ── auto-advance lock ── */
  const autoAdvancedRef = useRef<Set<number>>(new Set());
  /* ── tracks which question indices have been selected at least once ── */
  const firstSelectedRef = useRef<Set<number>>(new Set());

  /* Track viewport width so the spacer (which pushes content down while the
     bot is showing) matches the popup's actual mobile/desktop size. */
  const [viewportW, setViewportW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const onResize = () => setViewportW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const spacerH = (viewportW < 768 ? POPUP_H_MOBILE : POPUP_H_DESKTOP) + GAP + 8;

  /* Renders an invisible spacer right after a bot-guide anchor. This pushes
     the next question/field down in normal document flow so the fixed-position
     bot popup (which floats below the anchor) never overlaps/hides it. */
  const BotSpacer = ({ n }: { n: number }) => (
    <div style={{ height: botStep === n ? spacerH : 0, transition: "height .2s ease" }} />
  );

  const refBio      = useRef<HTMLDivElement>(null);
  const refContinue = useRef<HTMLDivElement>(null);
  const qRefs = useMemo(() => Array.from({ length: 9 }, () => React.createRef<HTMLDivElement>()), []);

  useEffect(() => {
    if (!localStorage.getItem("step4Guide")) {
      localStorage.setItem("step4Guide", "1");
      setTimeout(() => setBotStep(1), 700);
    }
  }, []);

  useEffect(() => {
    if (botStep === null) return;
    getBotRef(botStep)?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [botStep]);

  const nextBot = useCallback(() => setBotStep(p => p !== null && p < TOTAL_BOT ? p + 1 : null), []);
  const skipBot = useCallback(() => setBotStep(null), []);

  /* ── AUTO-ADVANCE BOT
   * targetStep pe 550ms baad silently move karo
   * Lock se double-jump prevent hota hai
   */
  const autoAdvanceBot = useCallback((targetStep: number) => {
    if (autoAdvancedRef.current.has(targetStep)) return;
    autoAdvancedRef.current.add(targetStep);
    setTimeout(() => {
      setBotStep(prev => {
        if (prev === targetStep - 1 || prev === targetStep) return targetStep;
        return prev;
      });
    }, 550);
  }, []);

  const getBotRef = (n: number): React.RefObject<HTMLDivElement | null> => {
    if (n === 1)             return refBio;
    if (n <= TOTAL_BOT - 1) return qRefs[n - 2];
    return refContinue;
  };

  const getBotData = (n: number): StepData => {
    if (n === 1) return {
      tag:    "STEP 1 OF 11 — YOUR BIO",
      plain:  "Write a short bio — tell others your interests and what makes you unique!",
      html:   <><strong>Write a short bio</strong> — tell others your interests and what makes you unique!</>,
      sideLg: "below",
    };
    if (n <= TOTAL_BOT - 1) {
      const q = stepQuestions[n - 2];
      return {
        tag:    `STEP ${n} OF ${TOTAL_BOT} — PERSONALITY`,
        plain:  q ? `${q.question} — pick the option that describes you best!` : "Select an option below!",
        html:   q ? <><strong>{q.question}</strong> — pick the option that describes you best!</> : <>Select an option below!</>,
        sideLg: "below",
      };
    }
    return {
      tag:    `STEP ${TOTAL_BOT} OF ${TOTAL_BOT} — ALL SET!`,
      plain:  "All done! Tap Continue to move to the next step!",
      html:   <>🚀 All done! <strong>Tap Continue</strong> to move to the next step!</>,
      sideLg: "below",
    };
  };

  /* Last step (continue) — NO zIndex */
  const gw = (n: number): React.CSSProperties => {
    if (n === TOTAL_BOT) return { position: "relative" };
    return { position: "relative", zIndex: botStep === n ? 9500 : 1 };
  };

  const handleNext = () => setCurrentIndex(p => p + 1);

  /* Bio change — 2s ke baad bot step 2 pe move */
  const handleChange = (value: string, key: string) => {
    handleInputChange(key, value);
    if (typingRef.current) clearTimeout(typingRef.current);
    typingRef.current = window.setTimeout(() => {
      if (value !== "") {
        handleNext();
        autoAdvanceBot(2); // bio done → Q1 pe move
      }
    }, 2000);
  };

  /* Option select — always allow reselection */
  const handleOptionSelect = (idx: number, qId: number, optId: number, nextBotStep: number) => {
    selectOption(qId, optId);
    if (!firstSelectedRef.current.has(idx)) {
      firstSelectedRef.current.add(idx);
      handleNext();
      autoAdvanceBot(nextBotStep);
    }
  };

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    if (validate4()) nextStep();
    else { setBtnLit(true); setTimeout(() => setBtnLit(false), 900); }
  };

  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    prevStep();
  };

  const charCount = inputs["know_about_you"]?.length || 0;

  const vis = (minIdx: number, qIdx: number) =>
    currentIndex >= minIdx ||
    (stepQuestions[qIdx]?.selected !== undefined && stepQuestions[qIdx]?.selected !== "");

  /* renderQ — now with auto-advance botN+1 ke liye, + a BotSpacer right after
     so the fixed-position popup for this step never overlaps the next block. */
  const renderQ = (
    sliceStart: number,
    sliceEnd:   number,
    botN:       number,       // current bot step number for this question
    visMinIdx:  number,
    qArrIdx:    number,
    ref:        React.RefObject<HTMLDivElement>,
  ) => (
    <>
      {stepQuestions.slice(sliceStart, sliceEnd).map((q: any) => (
        <div
          key={q.id} ref={ref}
          className={`ob4-q-block ${vis(visMinIdx, qArrIdx) ? "slide-in" : "slide-out"}`}
          style={gw(botN)}
        >
          <span className="ob4-q-title">{q.question}</span>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {q.questions_options.map((opt: any) => (
              <button
                key={opt.id}
                type="button"
                className={`ob4-pill${q.selected === opt.id ? " ob4-sel" : ""}`}
                onClick={() => {
                  const nextBotTarget = sliceStart === 8 ? TOTAL_BOT : botN + 1;
                  handleOptionSelect(qArrIdx, q.id, opt.id, nextBotTarget);
                  if (sliceStart === 8) { setBtnLit(true); setTimeout(() => setBtnLit(false), 900); }
                }}
                aria-pressed={q.selected === opt.id}
              >{opt.option}</button>
            ))}
          </div>
          {errors[`question_${q.id}`] && <p className="ob4-err">{errors[`question_${q.id}`]}</p>}
        </div>
      ))}
      <BotSpacer n={botN} />
    </>
  );

  return (
    <>
      {/* Bot popup — no overlay */}
      {botStep !== null && botStep >= 1 && botStep <= TOTAL_BOT && (
        <BotPopup
          anchorRef={getBotRef(botStep)}
          step={botStep} total={TOTAL_BOT}
          data={getBotData(botStep)}
          onSkip={skipBot}
          onNext={botStep < TOTAL_BOT ? nextBot : skipBot}
          nextLabel={botStep < TOTAL_BOT ? "Next →" : "Done ✓"}
        />
      )}

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container justify-content-center">
          <Link className="navbar-brand" to="/"><img src={logo} alt="Slammm" className="img-fluid" /></Link>
        </div>
      </nav>

      {/* Main section */}
      <section className="ob4-section onboarding_main_wraper py-60">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1">

              <div className="onboarding_step_top_wraper mb-4">
                <h2 className="mb-1" style={{ fontFamily: "'Inter',sans-serif", fontWeight: 800, letterSpacing: "-.02em" }}>
                  Tell us about yourself
                </h2>
                <p style={{ color: "#94a3b8", fontSize: 13, fontFamily: "'Inter',sans-serif", marginBottom: 10 }}>
                  Question 4/6
                </p>
                <div className="ob4-prog-wrap">
                  <div className="ob4-prog-bar done" />
                  <div className="ob4-prog-bar done" />
                  <div className="ob4-prog-bar done" />
                  <div className="ob4-prog-bar active" />
                  <div className="ob4-prog-bar" />
                  <div className="ob4-prog-bar" />
                </div>
              </div>

              <form className="onboarding_form" onSubmit={e => e.preventDefault()} onKeyDown={e => { if (e.key === "Enter") e.preventDefault(); }}>
                {stepQuestions.length > 0 ? (
                  <>
                    {/* ── Bio — Bot Step 1 anchor ── */}
                    <div
                      ref={refBio}
                      className={`ob4-q-block ${currentIndex >= 0 || inputs["know_about_you"] !== undefined ? "slide-in" : "slide-out"}`}
                      style={gw(1)}
                    >
                      <span className="ob4-q-title">What do you want other people to know about you?</span>
                      <textarea
                        className="ob4-textarea" rows={5}
                        placeholder="Write a short bio — your interests, personality, what makes you unique…"
                        maxLength={300}
                        onChange={e => handleChange(e.target.value, "know_about_you")}
                        onBlur={() => {
                          handleNext();
                          if (inputs["know_about_you"]) autoAdvanceBot(2);
                        }}
                        value={inputs["know_about_you"] || ""}
                      />
                      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
                        <span className="ob4-err" style={{ marginTop: 0 }}>{errors["know_about_you"] || ""}</span>
                        <span className={`ob4-char${charCount > 280 ? " over" : ""}`}>{charCount}/300</span>
                      </div>
                    </div>
                    <BotSpacer n={1} />

                    {/* ── 9 personality questions — each auto-advances to next bot step ── */}
                    {renderQ(0, 1,  2,  1, 0, qRefs[0] as React.RefObject<HTMLDivElement>)}
                    {renderQ(1, 2,  3,  2, 1, qRefs[1] as React.RefObject<HTMLDivElement>)}
                    {renderQ(2, 3,  4,  3, 2, qRefs[2] as React.RefObject<HTMLDivElement>)}
                    {renderQ(3, 4,  5,  4, 3, qRefs[3] as React.RefObject<HTMLDivElement>)}
                    {renderQ(4, 5,  6,  5, 4, qRefs[4] as React.RefObject<HTMLDivElement>)}
                    {renderQ(5, 6,  7,  6, 5, qRefs[5] as React.RefObject<HTMLDivElement>)}
                    {renderQ(6, 7,  8,  7, 6, qRefs[6] as React.RefObject<HTMLDivElement>)}
                    {renderQ(7, 8,  9,  8, 7, qRefs[7] as React.RefObject<HTMLDivElement>)}
                    {renderQ(8, 9, 10,  9, 8, qRefs[8] as React.RefObject<HTMLDivElement>)}
                  </>
                ) : (
                  <p style={{ textAlign: "center", padding: "40px 0", color: "#94a3b8", fontFamily: "'Inter',sans-serif" }}>
                    Loading questions…
                  </p>
                )}

                {/* ── Continue button — NO zIndex, hamesha clickable ── */}
                <div className="d-flex justify-content-between mt-4">
                  <button type="button" className="ob4-btn-back" onClick={handleBack}>
                    <i className="fa-solid fa-arrow-left" style={{ fontSize: 12 }} /> Back
                  </button>
                  <div ref={refContinue}>
                    <button type="button" onClick={handleSubmit} className={`ob4-btn-continue${btnLit ? " ob4-lit" : ""}`}>
                      Continue <i className="fa-solid fa-arrow-right" style={{ fontSize: 12 }} />
                    </button>
                  </div>
                </div>
                <BotSpacer n={TOTAL_BOT} />

              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step4;